/* Related Stories carousel — mirrors the product page "Combine with" arrows:
   transform-based scroll, prev/next disable at the ends. Per-view is derived
   from the real layout so it adapts across breakpoints. */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-rel-track]');
    var viewport = root.querySelector('[data-rel-viewport]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) {
      root.hidden = true;
      return;
    }
    var nav = root.querySelector('[data-rel-nav]');
    var prev = root.querySelector('[data-rel-prev]');
    var next = root.querySelector('[data-rel-next]');
    var index = 0;

    function step() {
      if (!items[0]) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    function perView() {
      var s = step();
      if (!s) return 1;
      var w = (viewport || track).getBoundingClientRect().width;
      return Math.max(1, Math.round(w / s));
    }

    function apply() {
      var max = Math.max(0, items.length - perView());
      if (index > max) index = max;
      if (index < 0) index = 0;
      track.style.transform = 'translateX(' + -index * step() + 'px)';
      if (nav) nav.hidden = items.length <= perView();
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
    }

    function go(i) {
      var max = Math.max(0, items.length - perView());
      index = Math.max(0, Math.min(max, i));
      apply();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    window.addEventListener('resize', apply);

    /* Make the whole card clickable (like the listing) without breaking links */
    items.forEach(function (card) {
      if (!card.dataset || !card.dataset.href) return;
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        window.location.href = card.dataset.href;
      });
    });

    apply();
  }

  function init() {
    document.querySelectorAll('[data-rel-stories]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
